import React, { useState, useEffect } from "react";
import { getPermission } from "utils/Utils";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PaginationComponent,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  Button,
  RSelect,
} from "components/Component";
import Content from "layout/content/Content";
import Head from "layout/head/Head";

import {
  Card,
  CardBody,
  Badge,
} from "reactstrap";
import { useCookies } from "react-cookie";
import moment from "moment";
import { serviceGetUsers } from "services/users";
import { serviceGetAuthHistory } from "services/auth-history";

const AuthHistory = () => {
  const [data, setData] = useState([]);
  const [cookies] = useCookies(["user"]);
  const [onSearchText] = useState("");
  const [currentPage] = useState(1);
  const [itemPerPage] = useState(15);
  const [metaData, setMetaData] = useState({});
  const [optionUser, setOptionUser] = useState([]);
  const [, setOptionPage] = useState([]);
  const [, setOptionLevel] = useState([]);
  const roleFunctions = getPermission()["oologs"]?.access || [];
  const [searchParam, setSearchParam] = useState({ roleId: "", pageId: "", accessLevelId: "", email:"" });
  const roleIdInputRef = React.useRef();


  // Changing state value when searching name
  useEffect(() => {
    if (onSearchText !== "") {
    } else {
      // setData([]);
    }
  }, [onSearchText, setData]);

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  // Change Page
  const paginate = (pageNumber) => refreshData(pageNumber);

  // unselects the data on mount
  useEffect(() => {
    refreshData(1);
    refreshOptions();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const refreshData = async (page) => {
    if (!roleFunctions.includes("read")) {
      return;
    }
    const response = await serviceGetAuthHistory(cookies.SIDikey, searchParam, [], page);
    if (response.status === 200) {
      const newData = [];
      response.data.data.forEach((da) => {
        da.createdBy = da.createdBy ? da.createdBy.firstName + " " + da.createdBy.lastName : null;
        da.modifiedBy = da.modifiedBy ? da.modifiedBy.firstName + " " + da.modifiedBy.lastName : null;
        newData.push(da);
      });
      setData(newData);
      const meta = response.data.meta;
      setMetaData(meta);
    }
  };

  const refreshOptions = async () => {
    if (!roleFunctions.includes("read")) {
      return;
    }

    // const responseUser = await serviceGetUsers(cookies.SIDikey, ["Access_All_Dept"], 1, 50);
    // const responseUser = await serviceGetUsers(cookies.SIDikey, ["Access_All_Dept"], 1, 50);
    const responseUser = await serviceGetUsers(
          cookies.SIDikey,
          roleFunctions,
          // cookies.departmentId,
          cookies.departmentIds,
          1,
          50,
          onSearchText,
          cookies.id
        );


    if (responseUser.status === 200) {
      setOptionUser(responseUser.data.data.map((item) => ({ label: item.firstName +' '+ item.lastName, value: item.email })));
      setOptionPage([]);
      setOptionLevel([]);
    } 
  };

  return (
    <React.Fragment>
      <Head title="Auth History"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Auth History
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
          <Card className="card-bordered my-4 card-bluesky">
            <CardBody className="card-bluesky-body">
              <strong>Info:</strong>
              <p>This page is used to checks auth history.</p>
            </CardBody>
          </Card>
          <Block className="d-flex justify-content-end">
            <BlockHeadContent>
            </BlockHeadContent>
          </Block>
        </BlockHead>
        <Block>
          <DataTable className="card-stretch">
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                <div className="role_search_input_container">
                  <div className="role_search_input">
                    <RSelect
                      ref={roleIdInputRef}
                      placeholder="Select User"
                      options={optionUser}
                      onChange={(e) => {
                        const currents = searchParam;
                        currents.email = e.value;
                        setSearchParam(currents);
                        refreshData(1);
                      }}
                    />
                  </div>
                  {/* <div className="role_search_input">
                    <RSelect
                      ref={pageIdInputRef}
                      placeholder="Select Page"
                      options={optionPage}
                      onChange={(e) => {
                        const currents = searchParam;
                        currents.pageId = e.value;
                        setSearchParam(currents);
                        refreshData(1);
                      }}
                    />
                  </div>
                  <div className="role_search_input">
                    <RSelect
                      ref={accessLevelIdInputRef}
                      placeholder="Select Level"
                      options={optionLevel}
                      onChange={(e) => {
                        const currents = searchParam;
                        currents.accessLevelId = e.value;
                        setSearchParam(currents);
                        refreshData(1);
                      }}
                    />
                  </div> */}
                  <Button
                    disabled={
                      searchParam.accessLevelId === "" && searchParam.pageId === "" && searchParam.email === ""
                    }
                    color="danger"
                    className="btn"
                    onClick={() => {
                      roleIdInputRef?.current?.select.setValue({ value: "", label: "Select User" });
                      // pageIdInputRef?.current?.select.setValue({ value: "", label: "Select Page" });
                      // accessLevelIdInputRef?.current?.select.setValue({ value: "", label: "Select level" });
                      const currents = searchParam;
                      currents.email = "";
                      setSearchParam(currents);
                      refreshData(1);
                    }}
                  >
                    <em className="icon ni ni-reload"></em>
                    <span>Reset</span>
                  </Button>
                  {/* <input type="text" className="form-control w-100" id="default-04" placeholder="Search" /> */}
                </div>
              </div>
            </div>
            <DataTableBody>
              <DataTableHead>
                <DataTableRow className="nk-tb-col-check">
                  <span className="sub-text">No</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Status</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Email</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Description</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Socket Id</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Created At</span>
                </DataTableRow>
              </DataTableHead>
              {/*Head*/}
              {currentItems.length > 0
                ? currentItems.map((item, idx) => {
                    return (
                      <DataTableItem key={item.id}>
                        <DataTableRow size="mb">
                          <span className="tb-amount">{(metaData.page - 1) * metaData.take + (idx + 1)}</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount text-light">
                            <Badge className="text-light" color={item?.status === 'ONLINE' ? "success" : "danger" } pill>{item?.status}</Badge>
                          </span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount">{item?.email}</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount">{item?.description}</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount">{item?.socketId}</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount">{moment(item.createdAt).format("DD MMM YYYY, HH:mm:ss")}</span>
                        </DataTableRow>
                      </DataTableItem>
                    );
                  })
                : null}
            </DataTableBody>
            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                  itemPerPage={metaData?.take}
                  totalItems={metaData?.itemCount}
                  paginate={paginate}
                  currentPage={metaData?.page}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
          </DataTable>
        </Block>
      </Content>
    </React.Fragment>
  );
};
export default AuthHistory;
